import { render, staticRenderFns } from "./ChatLogsTelegram.vue?vue&type=template&id=3d84f67a&scoped=true"
import script from "./ChatLogsTelegram.vue?vue&type=script&lang=js"
export * from "./ChatLogsTelegram.vue?vue&type=script&lang=js"
import style0 from "./ChatLogsTelegram.vue?vue&type=style&index=0&id=3d84f67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d84f67a",
  null
  
)

export default component.exports